import { BaseWebComponentRepository } from '../../framework/BaseWebComponentRepository';
import { PolicySelectorWebComponentSchema } from '../types/PolicySelectorWebComponentSchema';
import { PoliciesSelectorBaseDataProvider } from '../dataProvider/PoliciesSelectorBaseDataProvider';
import { PoliciesSelectorDataProviderFactory } from '../factory/PoliciesSelectorDataProviderFactory';
import { EditableModuleAndSection } from '../types';

export class PoliciesSelectorRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PoliciesSelectorDataProviderFactory;
  public dataProvider: PoliciesSelectorBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PoliciesSelectorDataProviderFactory(),
    });
  }

  async getPolicies(editableModuleAndSection: EditableModuleAndSection): Promise<PolicySelectorWebComponentSchema | undefined> {
    const response = await this.dataProvider.getPolicies(editableModuleAndSection);
    if (response['success']) {
      if (response['data'].length > 0) {
        for (let index = 0; index < response['data'].length; index++) {
          response['data'][index]['label'] = response['data'][index]['name'];
          response['data'][index]['value'] = response['data'][index]['_id'];
          delete response['data'][index]['_id'];
          delete response['data'][index]['name'];
        }
      }
    }
    return response;
  }
}
